import { connect } from 'react-redux';

import LungHelp from './LungHelp.js';

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {};
};

const ConnectedLungHelp = connect(
  mapStateToProps,
  mapDispatchToProps
)(LungHelp);

export default ConnectedLungHelp;
